import type { OrganizationFrame } from "@kontextwerk/control-web-client"
import type { RecordDetailHeaderPresentation } from "@kontextwerk/web-sdk/ui/layout/recordDetail/types"
import { mdiAccountOutline } from "@mdi/js"

export const userRecordIcon = mdiAccountOutline

/** Confirmed member facts; unknown values stay absent instead of being guessed. */
export type UserHeaderFacts = {
  /** Display name of the membership role, never a legacy user role. */
  role: string | null
  /** Only an admitted e-mail address. */
  email: string | null
}

export const buildUserHeader = (
  facts: UserHeaderFacts,
  organization: Pick<OrganizationFrame, "name"> | null,
): RecordDetailHeaderPresentation => {
  const fields: RecordDetailHeaderPresentation["fields"] = []
  const role = facts.role?.trim()
  const email = facts.email?.trim()
  const organizationName = organization?.name?.trim()

  if (role) fields.push({ id: "role", label: "Rolle", value: role })

  if (email) fields.push({ id: "email", label: "E-Mail", value: email })

  if (organizationName) {
    fields.push({ id: "organization", label: "Organisation", value: organizationName })
  }

  return { icon: userRecordIcon, fields }
}
